import { store } from '@sonifi/wb-core/store/store';
import { buildApiParamsPagination } from '@sonifi/wb-widget/store/tableConfig/tableConfigInitialState';
import {
  getJobById,
  getJobs,
  initRowExpanded,
} from '../jobs/services/jobs.service';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';

function checkIfJobsAreLoaded(apiParams) {
  const state = store.getState();
  const {
    adminJobs: { loadingJobs, jobs },
  } = state;
  const currentPagination = state.tableConfig.pagination[TABLE_KEYS.adminJobs];

  // If jobs are loaded and params match, just update expanded state without refetching
  if (
    loadingJobs === LOADING_STATUS.success &&
    jobs.length > 0 &&
    currentPagination &&
    currentPagination.page === apiParams.page &&
    currentPagination.pageSize === apiParams.pageSize &&
    currentPagination.query === apiParams.query &&
    currentPagination.sortBy === apiParams.sortBy &&
    currentPagination.sortDir === apiParams.sortDir
  ) {
    return true;
  }
  return false;
}

export async function loaderJobs({ request }) {
  const apiParams = buildApiParamsPagination(request);

  // Clear expanded row
  store.dispatch(initRowExpanded(null));

  // If jobs are loaded and params match, just update expanded state without refetching
  if (checkIfJobsAreLoaded(apiParams)) {
    return {};
  }

  await store.dispatch(getJobs(apiParams));
  return {};
}

export async function loaderJobById({ params, request }) {
  const { id } = params;

  const expandedRowId = parseInt(id);

  const apiParams = buildApiParamsPagination(request);
  if (!checkIfJobsAreLoaded(apiParams)) {
    await loaderJobs({ request });
  }

  store.dispatch(initRowExpanded(expandedRowId));
  if (expandedRowId) {
    // Don't wait here because uses the internal loading in the WbTable
    store.dispatch(getJobById(expandedRowId));
  }

  return {};
}
